<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6 class="upper-text">Deseja realmente duplicar a prescrição?</h6>

        <h6 class="upper-text worksansr">
          Período de validação da prescrição:
        </h6>
      </div>
      
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <h6 class="upper-text worksansr">DATA DE INÍCIO</h6>
        <input v-model="start_date" type="date" class="form-control" />
      </div>
      
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <h6 class="upper-text worksansr">DATA DE TÉRMINO</h6>
      
        <input v-model="end_date" type="date" class="form-control" />
      </div>
      
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6>RESIDENTE:</h6>
      
        <input
          disabled
          type="text"
          v-model="resident_name"
          class="form-control"
        />
      </div>
      
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <ErrorsMessages :errors="errors" />
      </div>
      
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center back-ground-grey">
        <h6 class="mb-0">FINALIZAR</h6>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <v-btn :disabled="loading" @click="duplicate" class="btn-notcertified">
          <i class="fas fa-check mr-2 text-twenty"></i>
          FINALIZAR MANUAL
          {{ loading ? "CARREGANDO" : "COM ASSINATURA ELETRÔNICA" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import { userData } from "../../../lib/functions";

export default {
  name: "GroupCareDuplicate",

  components: {
    ErrorsMessages,
  },

  props: {
    id: [String, Number],

    resident_name: String,
  },

  data() {
    return {
      rest_home_id: null,

      resident_id: null,

      user_id: "",

      start_date: "",

      end_date: "",

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      let { user } = userData();

      this.rest_home_id = user.rest_home_id;
      
      this.user_id = user.id;
    },

    async duplicate() {
      try {
        this.loading = true;

        let { id, rest_home_id, user_id, start_date, end_date } = this;

        let params = {
          id,
          rest_home_id,
          user_id,
          start_date,
          end_date,
        };

        const response = await api.post(
          "/rest-home/duplicate/group-prescription-care",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("duplicate", "paginate");
          
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        
        console.log(error);
      }
    },
  },
};
</script>
